var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ToS_icon",
    "data-name": "ToS icon",
    transform: "translate(-28 -325)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Boundary",
    width: 30,
    height: 30,
    rx: 13,
    transform: "translate(28 355) rotate(-90)",
    fill: "#1e2033",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1579",
    "data-name": "Path 1579",
    d: "M42.916,331.826l1.982.26,1.674,1.137,1.188,1.594.568,2.357s-.049,2.338-.082,2.42-1.17,1.51-1.268,1.689-1.447,1.561-1.447,1.561v2.17H40v-2.941l-1.658-1.592-.553-1.432-.227-2.145s.293-1.445.373-1.641,1.121-1.428,1.219-1.543,1.951-1.186,1.982-1.252S42.916,331.826,42.916,331.826Z",
    fill: "#ebecff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-lightbulb-outline",
    "data-name": "Icon material-lightbulb-outline",
    d: "M11.192,20.538a.926.926,0,0,0,.923.923h3.692a.926.926,0,0,0,.923-.923v-.923H11.192ZM13.962,3a6.459,6.459,0,0,0-3.692,11.76v2.086a.926.926,0,0,0,.923.923h5.538a.926.926,0,0,0,.923-.923V14.76A6.459,6.459,0,0,0,13.962,3Zm2.631,10.246-.785.554v2.123H12.115V13.8l-.785-.554a4.615,4.615,0,1,1,5.262,0Z",
    transform: "translate(29.039 328.022)",
    fill: "#ebecff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTos);
export default __webpack_public_path__ + "static/media/tos.892f8990.svg";
export { ForwardRef as ReactComponent };